import React, { useState } from "react";
import { PageHero } from "@/components/common/SectionHeading";
import { submitCampusVisit } from "@/lib/lnlApi";
import { toast } from "sonner";

export default function CampusVisit() {
    const [f, setF] = useState({ visitor_name:"", mobile:"", email:"", applicant_type:"", preferred_program:"", guests:1, preferred_date:"", preferred_time:"", purpose:"", accessibility_needs:"", consent:false });
    const [ref, setRef] = useState(null);
    async function submit(e) {
        e.preventDefault();
        if (!f.consent) return toast.error("Please give privacy consent.");
        try { const r = await submitCampusVisit(f); setRef(r.reference); toast.success("Visit requested"); }
        catch { toast.error("Could not submit request."); }
    }
    return (
        <div data-testid="campus-visit-page">
            <PageHero eyebrow="Campus visit" title="Book a campus visit" description="Requests are not automatically confirmed — Admissions will reach out to schedule a specific time." breadcrumbs={[{label:"Home",to:"/"},{label:"Contact",to:"/contact"},{label:"Campus Visit"}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container max-w-2xl">
                    {!ref ? (
                        <form onSubmit={submit} className="lnl-card p-6 grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="visit-form">
                            {[
                                ["visitor_name","Visitor name","text"],["mobile","Mobile","tel"],["email","Email","email"],
                                ["applicant_type","Applicant type","text"],["preferred_program","Preferred program","text"],
                                ["preferred_date","Preferred date","date"],["preferred_time","Preferred time","text"],["purpose","Purpose","text"],["accessibility_needs","Accessibility needs","text"],
                            ].map(([k,l,t]) => (
                                <div key={k} className={k==="purpose"||k==="accessibility_needs"?"sm:col-span-2":""}>
                                    <label className="text-xs text-lnl-gray font-heading font-semibold">{l}</label>
                                    <input type={t} value={f[k]||""} onChange={(e)=>setF({...f,[k]:e.target.value})} className="mt-1 w-full rounded-md border border-lnl-border px-3 py-2.5" data-testid={`visit-${k}`} required={["visitor_name","mobile","email","preferred_date"].includes(k)} />
                                </div>
                            ))}
                            <div>
                                <label className="text-xs text-lnl-gray font-heading font-semibold">Number of guests</label>
                                <input type="number" min="1" value={f.guests} onChange={(e)=>setF({...f,guests:Number(e.target.value)})} className="mt-1 w-full rounded-md border border-lnl-border px-3 py-2.5" data-testid="visit-guests" />
                            </div>
                            <label className="sm:col-span-2 flex items-start gap-2 text-xs text-lnl-gray">
                                <input type="checkbox" checked={f.consent} onChange={(e)=>setF({...f,consent:e.target.checked})} data-testid="visit-consent" />
                                I consent to be contacted by LNL to schedule this visit.
                            </label>
                            <div className="sm:col-span-2"><button className="lnl-btn-primary" data-testid="visit-submit">Request visit</button></div>
                        </form>
                    ) : (
                        <div className="lnl-card p-6"><div className="font-heading text-xl font-bold">Requested</div><div className="mt-1 text-sm">Reference: <b>{ref}</b>. LNL will confirm your visit shortly.</div></div>
                    )}
                </div>
            </section>
        </div>
    );
}
